// The bus pin finder as BASIC source, for typing it in. It is the same program as
// samples/iecfind.prg (tools/test_prgs/iecfind.bas; a test keeps them equal).
// On the C64 type it in lowercase; the screen shows it as capitals.
import { assetUrl } from '../core/assets.js';
export const IECFIND_LISTING = `10 rem iec pin finder
20 b=peek(56576)and199
30 print chr$(147);"iec pin finder"
40 print "press any key to stop"
50 g=75
60 print "data":m=32:n=10:gosub 500
70 print "clk":m=16:n=7:gosub 500
80 print "atn":m=8:n=4:gosub 500
90 print "heartbeat (clk)":g=40
100 m=16:n=2:gosub 500:goto 100
500 for i=1 to n
510 poke 56576,b or m
520 w=3:gosub 600
530 poke 56576,b
540 w=3:gosub 600
550 next
560 w=g:gosub 600
570 return
600 t=ti
610 get k$:if k$<>"" then 900
620 if ti-t<w then 610
630 return
900 poke 56576,b:print "stopped":end`;
export const IECFIND_PRG_URL = assetUrl('samples/iecfind.prg');
